import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BadgeSelectorService } from './badge-selector.service';

@Component({
  selector: 'cv-badge-selector',
  templateUrl: './badge-selector.component.html',
  styleUrls: ['./badge-selector.component.scss']
})
export class BadgeSelectorComponent implements OnInit {
  @Input() header: string;
  @Input() showWhen: boolean;
  @Input() showCustomBadge: boolean = true;
  @Output() onBadgeSelected: EventEmitter<number> = new EventEmitter<number>();

  bss: any = null;
  badges = [];
  viewSettings = {
    badgeSize: 70,
    columns: 6,
    rows: 4
  }
  selectedBadge: number;
  customBadgeCreatorVisible: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    private badgeSelectorService: BadgeSelectorService
  ) {
    this.bss = this.badgeSelectorService.data;
    this.badges = this.bss.badges;
  }

  ngOnInit(): void {
    if (this.bss.badgesLoaded) {
      this.badgeSelectorService.loadBadges();
    }
  }

  close(): void {
    this.activeModal.close();
  }

  openCustomBadgeDialog(){
    this.customBadgeCreatorVisible = true;
  }

  selectBadge(badgeID: number): void {
    this.selectedBadge = badgeID;
  }

  selectAndClose() {
    this.onBadgeSelected.emit(this.selectedBadge);
    this.activeModal.close();
  }

  customBadgeSaved(imageID: number): void {
    this.bss.badges.push(imageID);
    this.selectBadge(imageID);
    this.selectAndClose();
    this.customBadgeCreatorVisible = false;
  }
}